import React from 'react';
import moment from 'moment';

function HubListComp(props) {

    return (
      <>
        {/* <a href="#" onClick={(e) => { props.openHubModal(e, props.data.id)}}> */}
        <a href={`https://portahead.com/login?redirect_uri=/hub/${props.data.url}`} target="_blank" rel="noopener noreferrer">
            <div className="d-flex img-cont">
                <div className="img-logo">
                    <img src={props.data.logo} alt={props.data.title} />
                </div>
                <p className="heading ms-2">{props.data.title}</p>
            </div>
            <p className="sub-content">
                {props.data.key_benefit
                    ? <span>{props.data.key_benefit}</span>
                    : <>&nbsp;</>
                }</p>
            <p className="sub-content">
                Age:&nbsp;
                {props.data.age_details.map((age_d, age_index) => (
                    <span key={`hub_age${age_index}`}>
                        {age_d.label}
                        {age_index !==props.data.age_details.length - 1 && (<>, &nbsp;</>)}
                    </span>
                ))}
            </p>
            <p className="sub-content">Expiry: {moment(props.data.expiry_at).format("Do MMM YYYY")}</p>
            <div>
                <p className={`me-3 w-100 ${props.fetch_key && props.fetch_key === "port_list_page" ? 'text-start' : 'text-end'}`}>
                {props.data.fee_id !== 13
                    ? <span>{props.data.fee}</span>
                    : <>&nbsp;</>
                }
                </p>
            </div>
            {props.fetch_key && props.fetch_key === "port_list_page" && (
                <p className="text-end fs-12p mb-0 text-white-50">Click for Details</p>
            )}
        </a>
      </>
    );
  }
  
  export default HubListComp;